import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import InputMask from "react-input-mask";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";
import Util from "../../../actions/util.js";
import DataUtil from "../../../actions/data.js";

import ConsultaPacienteResultado from "./ConsultaPacienteResultado";

class ConsultaPaciente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulta: {
        cadastroDe: "01/01/2000",
        cadastroAte: DataUtil.hoje(),
        idCismepar: "",
        dataNascimento: "",
        nome: "",
        tipoInativacao: 0,
        cidade: "",
        classificacao: 0,
      },
      resultado: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();

    let data = this.state.consulta;
    if (!DataUtil.validarData(data.cadastroDe)) {
      data.cadastroDe = "01/01/2000";
    }
    if (!DataUtil.validarData(data.cadastroAte)) {
      data.cadastroAte = DataUtil.hoje();
    }
    if (!DataUtil.validarData(data.dataNascimento)) {
      data.dataNascimento = "";
    }

    UI.loader("show", "Um momento...");
    API.post("/pacientes/consulta", data)
      .then(
        function (json) {
          this.setState({ resultado: json.data });
          UI.loader("hide");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  exportarCSV() {
    if (!Util.exportarPacientesCSV(this.state.resultado)) {
      UI.alert(false, "Não há nenhum resultado para ser exportado.");
    }
  }

  handleChange(event) {
    let consulta = this.state.consulta;
    consulta[event.target.name] = event.target.value;
    this.setState({ consulta: consulta });
  }

  render() {
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="card-title">CONSULTA PACIENTE</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      onClick={() => {
                        this.props.history.push("/paciente/cadastro");
                      }}
                      className="btn btn-rounded btn-icons btn-outline-success"
                      type="button"
                    >
                      <i className="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <p className="card-description" />
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group row">
                      <div className="col-md-3">
                        <label>Cadastrado Desde</label>
                        <InputMask
                          placeholder="CADASTRADO DE"
                          name="cadastroDe"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.cadastroDe}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Cadastrado Até</label>
                        <InputMask
                          placeholder="CADASTRADO ATÉ"
                          name="cadastroAte"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.cadastroAte}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-sm-3">
                        <label>CPF / ID Cismepar</label>
                        <input
                          placeholder="CPF ou ID CISMEPAR"
                          name="idCismepar"
                          type="text"
                          className="form-control"
                          value={this.state.consulta.idCismepar}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-sm-3">
                        <label>Data Nascimento</label>
                        <InputMask
                          placeholder="DATA NASCIMENTO"
                          name="dataNascimento"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.dataNascimento}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-3">
                        <label>Nome</label>
                        <input
                          autoFocus
                          placeholder="NOME"
                          name="nome"
                          type="text"
                          className="form-control"
                          value={this.state.consulta.nome}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-sm-3">
                        <label>Situação</label>
                        <select
                          disabled={this.state.inativo ? true : false}
                          name="tipoInativacao"
                          className="form-control"
                          value={this.state.tipoInativacao}
                          onChange={this.handleChange}
                        >
                          <option value={0}>ATIVO</option>
                          <option value={1}>INATIVO (SEM MOTIVO)</option>
                          <option value={2}>ALTA</option>
                          <option value={3}>DESLIGAMENTO</option>
                          <option value={4}>ENCAMINHAMENTO</option>
                          <option value={5}>OUTROS</option>
                        </select>
                      </div>
                      <div className="col-sm-3">
                        <label>Cidade</label>
                        <input
                          placeholder="CIDADE"
                          name="cidade"
                          type="text"
                          className="form-control"
                          value={this.state.consulta.cidade}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-sm-3">
                        <label>Classificação</label>
                        <select
                          name="classificacao"
                          className="form-control"
                          value={this.state.classificacao}
                          onChange={this.handleChange}
                        >
                          <option value={0}>TODAS</option>
                          <option value={1}>GESTANTE</option>
                          <option value={2}>ESTIMULAÇÃO PRECOCE</option>
                          <option value={3}>CRIANÇA</option>
                          <option value={4}>HIPERTENSÃO</option>
                          <option value={5}>DIABETE</option>
                          <option value={6}>IDOSO</option>
                          <option value={7}>GINECOLOGIA</option>
                          <option value={8}>SAÚDE MENTAL</option>
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 text-right">
                        <button
                          type="button"
                          className="btn btn-sm btn-success mb-2"
                          onClick={() => this.exportarCSV()}
                        >
                          <i className="fa fa-download"></i>&nbsp; Exportar CSV
                        </button>
                        &nbsp;
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary mb-2"
                        >
                          <i className="fa fa-search"></i>&nbsp; Pesquisar
                        </button>
                      </div>
                    </div>
                    <ConsultaPacienteResultado
                      resultado={this.state.resultado}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default withRouter(ConsultaPaciente);
